import React from "react";
import "./AddStore.css";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { FaStar } from "react-icons/fa";
import { useJwt } from "react-jwt";
import { CreateStore } from "../apiconfig/authService";
import { toast } from "react-toastify";
import { RiLoaderFill } from "react-icons/ri";

function AddStore(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setMediaTableViewMessage = props.setMessage;

  const [mediaTitle, setMediaTitle] = useState("");
  const [webUrl, setWebUrl] = useState("");
  const [mediaImage, setMediaImage] = useState(null);
  const [supportImage, setSupportImage] = useState(null);
  const [statusid, setStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);
  const [supportUrl, setSupportUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleTitleChange = (e) => {
    setMediaTitle(e.target.value);
  };

  const handleWebChange = (e) => {
    setWebUrl(e.target.value);
  };
  const handleSupportUrl = (e) => {
    setSupportUrl(e.target.value);
  };

  const handleImageChange = (e) => {
    setMediaImage(e.target.files[0]);
  };
  const handleSupportImage = (e) => {
    setSupportImage(e.target.files[0]);
  };
  const handleStatusIdChange = (e) => {
    setStatusid(e.target.value);
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (!mediaTitle.trim()) {
        toast.error("Store Name is required!");
        return;
      }
      if (mediaImage === null) {
        toast.error("Store Image is required!");
        return;
      }
      if (!webUrl.trim()) {
        toast.error("Web URL is required!");
        return;
      }
      const urlPattern = /^https:\/\/www\.[a-zA-Z0-9-]+\.[a-z]{2,}$/;
      if (!urlPattern.test(webUrl)) {
        toast.error("Please enter a valid Web URL (e.g., https://www.example.com)");
        return;
      }
      if (!supportUrl.trim()) {
        toast.error("Support URL is required!");
        return;
      }
      if (!urlPattern.test(supportUrl)) {
        toast.error("Please enter a valid Support URL (e.g., https://www.example.com)");
        return;
      }
      if (supportImage === null) {
        toast.error("Support Image is required!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const formData = new FormData();
    formData.append("storename", mediaTitle);
    formData.append("image", mediaImage);
    formData.append("weburl", webUrl);
    formData.append("supporturl", supportUrl);
    formData.append("supportimage", supportImage);
    try {
      setLoading(true);
      response = await CreateStore(
        formData,
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setLoading(false);
        toast.success("Store Added Successfully");
        setMediaTableViewMessage(response?.data?.message);
        navigate("/stores");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      }
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const statusResponse = await GetProductStatus(
  //         localStorage.getItem("accessToken")
  //       );
  //       setStatusData(statusResponse.data);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   })();
  // }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Store</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/stores" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <div className="d-flex">
                <label htmlFor="catName">Store Title</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={mediaTitle}
                onChange={handleTitleChange}
                className="form-control  custom-input my-2"
                id="catName"
                placeholder="Store Title"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <div className="d-flex">
                <label htmlFor="catImg">Store Image</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="file"
                name="image"
                className="form-control custom-input my-2"
                onChange={handleImageChange}
                id="catImg"
                placeholder="Store Image"
              />
              {/* </div> */}
            </div>
          </div>
          {/* <div className="form-floating mb-4"> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catName">Web Url</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={webUrl}
                onChange={handleWebChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Web Url"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="catName">Support Url</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={supportUrl}
                onChange={handleSupportUrl}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Support Url"
              />
            </div>
          </div>
          <div className="form-group col-sm-12 col-lg-12 mb-3">
            <div className="d-flex">
              <label htmlFor="catName">Support Image</label>
              <FaStar size={7} className="text-danger" />
            </div>
            <input
              type="file"
              name="image"
              className="form-control custom-input my-2"
              onChange={handleSupportImage}
              id="catImg"
              placeholder="Support Image"
            />
          </div>
          {/* </div> */}
          {/* <div className="form-floating mb-4">
                  <select className="form-select" onChange={handleStatusIdChange} value={statusid} >
                    { 
                      statusData?.map((item) => (
                      <option value={item.statusid}>
                        {item.status}
                      </option>
                      ))
                    }
                  </select>
                  <label htmlFor="floatingInput">Status</label>
            </div> */}

          <div className="row">
            <div className="col-12" style={{ height: "40px", width: "80px" }}>
              {loading ? (
                <div
                  className="btn btn-primary loader-active save-btn"
                  style={{ height: "100%", width: "100%" }}
                >
                  <RiLoaderFill
                    size={20}
                    className="spin-animation"
                    color="white"
                  />
                </div>
              ) : (
                <button
                  type="submit"
                  onClick={handleSubmitClick}
                  disabled={loading}
                  className="btn btn-primary save-btn text-uppercase"
                  style={{ height: "100%", width: "100%" }}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}

export default AddStore;
